/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import ServicesCard from "./ServicesCard";
import { useBooking } from "../../hooks/useBooking";
import { useTimeSlotSelection } from "../../hooks/useTimeSlotSelection";

const SelectedServicesCard = ({ services, canEdit, canDelete, canSelect, bookings }) => {
  const { setSelectedServices, setSelectedTime, selectedServices, selectedDate, selectedTime, membershipAccessGrants } = useBooking();
  const { validateTimeSlot } = useTimeSlotSelection();

  const handleDeleteService = async (e, serviceId) => {
    e.stopPropagation();

    const updatedServices = selectedServices.filter((service) => service.id !== serviceId);

    setSelectedServices(updatedServices);

    if (updatedServices.length === 0) {
      setSelectedTime(null);
      return;
    }

    if (selectedTime && selectedDate) {
      await validateTimeSlot(selectedDate, selectedTime, updatedServices);
    }
  };

  return (
    <ServicesCard
      services={services}
      canEdit={canEdit}
      canDelete={canDelete}
      canSelect={canSelect}
      onDelete={(e, serviceId) => handleDeleteService(e, serviceId)}
      bookings={bookings}
      membershipAccessGrants={membershipAccessGrants}
    />
  );
};

export default SelectedServicesCard;
